<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Fluxos de Processos</h1>
                                    <p class="modern-subtitle">Configure fluxos automáticos para seus processos inteligentes</p>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div class="table-container">
                        <div class="table-wrapper">
                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <button @click="abrirModalInclusao" class="modern-btn modern-btn-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Novo Fluxo
                                </button>
                                <!--<div class="search-box">
                                    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                    <input v-model="pagFilter" type="text" class="modern-search-input" placeholder="Buscar">
                                </div>-->
                            </div> <!-- custom-table-header -->
                            <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <!-- Header -->
                                <thead>
                                    <tr>
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 30%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Nome do Fluxo</span>
                                            </div>
                                        </th>
                                        <!-- Coluna Tipo de Processo-->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 30%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Tipo de Processo</span>
                                            </div>
                                        </th>
                                        <!-- Coluna Legislação -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 30%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Legislação</span>
                                            </div>
                                        </th>
                                        <!-- Coluna Status -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100"
                                            style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Status</span>
                                            </div>
                                        </th>
                                        <!-- Coluna Data de Inclusão -->
                                        <th class="select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                            <div class="th-wrapper">
                                                <span class="th-title">Data de Inclusão</span>
                                            </div>
                                        </th>
                                        <th scope="col" class="text-center bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Ações</th>
                                    </tr>
                                </thead>
                                <!-- Body -->
                                <tbody>
                                    <tr v-for="processo in processosWorkflow" :key="processo.processoWorkflow.idProcessoWorkflow">
                                        <td data-label="Nome do Fluxo" class="text-center fw-semibold">
                                            {{ processo.processoWorkflow.nmProcessoWorkflow || 'Sem nome' }}
                                        </td>
                                        <td data-label="Tipo de Processo" class="text-center">
                                            {{ tipoProcessoById[processo.processoWorkflow.idTipoProcesso] || '—' }}
                                        </td>
                                        <td data-label="Legislação" class="text-center">
                                            {{ legislacaoById[processo.processoWorkflow.idLegislacao] || '—' }}
                                        </td>
                                        <td data-label="Status" class="text-center">
                                            <span class="status-badge"
                                                  :class="processo.processoWorkflow.flAtivo ? 'status-badge--ativo' : 'status-badge--inativo'">
                                                {{ processo.processoWorkflow.flAtivo ? 'Ativo' : 'Inativo' }}
                                            </span>
                                        </td>

                                        <td data-label="Data de Inclusão" class="text-center">
                                            {{ formatarData(processo.processoWorkflow.dtInclusao) }}
                                        </td>
                                        <td data-label="Ações" class="text-center action-cell" style="white-space: nowrap; width: 1%;">
                                            <div class="action-buttons" :class="{ 'actions-disabled': !processo.processoWorkflow.flAtivo }">

                                                <button @click="processo.processoWorkflow.flAtivo && abrirDetalhes(processo.processoWorkflow.idProcessoWorkflow)"
                                                        class="action-btn action-btn-view"
                                                        :disabled="!processo.processoWorkflow.flAtivo"
                                                        :title="processo.processoWorkflow.flAtivo ? 'Ver Detalhes' : 'Fluxo inativo'">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                    </svg>
                                                    <span class="action-text">Detalhes</span>
                                                </button>

                                                <button @click="processo.processoWorkflow.flAtivo && inativarProcessoWorkflow(processo.processoWorkflow.idProcessoWorkflow)"
                                                        class="action-btn action-btn-delete"
                                                        :disabled="!processo.processoWorkflow.flAtivo"
                                                        :title="processo.processoWorkflow.flAtivo ? 'Inativar Fluxo' : 'Fluxo inativo'">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                    </svg>
                                                    <span class="action-text">Inativar</span>
                                                </button>

                                            </div>
                                        </td>

                                    </tr>
                                    <tr v-if="processosWorkflow.length === 0">
                                        <td colspan="6" class="empty-state">
                                            <div class="empty-content">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                </svg>
                                                <h3 class="empty-title">Nenhum fluxo encontrado</h3>
                                                <p class="empty-description">Crie seu primeiro fluxo para automatizar processos</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                <div class="pagination-controls flex items-center">
                                    <span @click="previousPage"
                                          :class="['page-box', { 'disabled': currentPage === 0 }]">
                                        <span class="navigation-symbol">«</span>
                                    </span>
                                    <span v-for="page in pagesToShow"
                                          :key="page"
                                          @click="goToPage(page)"
                                          :class="['page-box',page === currentPage ? 'btn btn-primary-soft' : '']">
                                        {{ page + 1 }}
                                    </span>

                                    <span @click="nextPage"
                                          :class="['page-box', { 'disabled': !temProximaPagina }]">
                                        <span class="navigation-symbol">»</span>
                                    </span>
                                </div> <!-- pagination-controll -->
                                <span class="text-sm font-semibold text-gray-600">Registros encontrados: {{ qtdRegistros }}</span>
                            </div> <!-- custom-table-footer -->
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>
        <!-- MODAL NOVO WORKFLOW -->
        <div class="modal fade modern-modal" id="ModalWorkflowInclusao" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-lg">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Novo Fluxo</h2>
                            <p>Complete os campos para criar um fluxo automatizado associado aos seus processos inteligentes.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="intro-text">
                            Dê um nome ao fluxo e defina a legislação e o tipo de processo vinculados. Uma mesma combinação pode possuir vários fluxos.
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="nomeWorkflow">Nome do fluxo</label>
                            <input id="nomeWorkflow"
                                   v-model.trim="nomeWorkflow"
                                   type="text"
                                   maxlength="500"
                                   class="form-control"
                                   :class="{ 'border-danger': camposInvalidos.nomeWorkflow }"
                                   placeholder="Ex.: Fluxo padrão para contratação direta" />
                        </div>
                        <div class="form-grid form-grid-2">
                            <div class="form-group">
                                <label class="form-label">Legislação</label>
                                <select class="form-control"
                                        v-model="legislacaoSelecionadaId"
                                        :class="{ 'border-danger': camposInvalidos.legislacaoSelecionadaId }">
                                    <option disabled value="">Selecione uma Legislação</option>
                                    <option v-for="(leg, index) in legislacoes" :key="index" :value="leg.idLegislacao">
                                        {{ leg.dsNome }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Tipo de Processo</label>
                                <select class="form-control"
                                        v-model="ProcessoSelecionadoId"
                                        :class="{ 'border-danger': camposInvalidos.ProcessoSelecionadoId }">
                                    <option disabled value="">Selecione um Tipo</option>
                                    <option v-for="(proc, index) in tiposProcessos" :key="index" :value="proc.idTipoProcesso">
                                        {{ proc.nmTipoProcesso }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="info-chip">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .876-.252 1.02-.598l.088-.416c.066-.3.104-.378.288-.41l.451-.083.082-.38-1.428-.287.545-2.545z" />
                                <circle cx="8" cy="4.5" r="1" />
                            </svg>
                            O nome diferencia fluxos que usam a mesma legislação e o mesmo tipo de processo.
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button" class="modern-btn modern-btn-primary w-100" @click="salvarProcessoWorkflow">
                            Salvar Fluxo
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div> <!-- tyn-root-->
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import axios from 'axios'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import Swal from 'sweetalert2'

    export default {
        name: 'ProcessoWorkflow',
        components: { Header, Modais },
        data: function () {
            return {
                pagFilter: '',
                processosWorkflow: [],
                legislacoes: [],
                qtdRegistros: 0,
                nomeWorkflow: '',
                legislacaoSelecionadaId: '',
                ProcessoSelecionadoId: '',
                mostrarModalInclusao: false,
                tiposProcessos: [],
                currentPage: 0,
                pageSize: 7,
                debounceTimeout: null,
                camposInvalidos: {
                    nomeWorkflow: false,
                    dsNomeProcesso: false,
                    legislacaoSelecionadaId: false,
                    flLoteUnico: false,
                    ProcessoSelecionadoId: false,
                    cdProcessoNumero: false
                },
            }
        },
        watch: {
            pagFilter: {
                handler() {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => {
                        this.currentPage = 0;
                        this.getProcessosWorkflow();
                    }, 500);
                }
            }
        },

        methods: {
            load() {
                if (!this.canAccess) {
                    this.$router.replace({ name: 'Home' })
                    return
                }
                this.getProcessosWorkflow()
                this.getLegislacoes()
                this.getProcessosTipo()
            },

            getProcessosWorkflow() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflow`, {
                    params: {
                        index: $this.currentPage,
                        take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.processosWorkflow = result.rows.map(p => ({
                                ...p,
                            }));
                            $this.qtdRegistros = result.qtdRecords;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar fluxos!", "warning");
                    });
            },

            getLegislacoes() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/GetLegislacoesProduto/`, { showLoading: false, params: { cdIdentificador: 'PI' } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacoes = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar Legislações!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                        $this.loading.hide();
                    });
            },

            getProcessosTipo() {
                let $this = this;
                axios.get(`${urlApi}/TipoProcesso/Get`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.tiposProcessos = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar processos!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                        $this.loading.hide();
                    });
            },

            resetFormWorkflow() {
                this.nomeWorkflow = '';
                this.legislacaoSelecionadaId = '';
                this.ProcessoSelecionadoId = '';
                this.camposInvalidos.nomeWorkflow = false;
                this.camposInvalidos.legislacaoSelecionadaId = false;
                this.camposInvalidos.ProcessoSelecionadoId = false;
            },

            abrirModalInclusao() {
                this.resetFormWorkflow();

                const el = document.getElementById('ModalWorkflowInclusao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const modal = new bs.Modal(el);
                    modal.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal({ backdrop: 'static', keyboard: false, show: true });
                }

            },

            async salvarProcessoWorkflow() {
                this.camposInvalidos.nomeWorkflow = !this.nomeWorkflow.trim();
                this.camposInvalidos.legislacaoSelecionadaId = !this.legislacaoSelecionadaId;
                this.camposInvalidos.ProcessoSelecionadoId = !this.ProcessoSelecionadoId;

                if (this.camposInvalidos.nomeWorkflow ||
                    this.camposInvalidos.legislacaoSelecionadaId ||
                    this.camposInvalidos.ProcessoSelecionadoId) {
                    avisoErro("Preencha os campos obrigatórios.");
                    return;
                }

                const payload = {
                    DadosProcessoWorkflow: {
                        idProcessoWorkflow: 0,
                        nmProcessoWorkflow: this.nomeWorkflow.trim(),
                        idLegislacao: parseInt(this.legislacaoSelecionadaId),
                        idTipoProcesso: parseInt(this.ProcessoSelecionadoId),
                    },
                };

                try {
                    const res = await axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflow`, payload);

                    if (!res.data?.success) {
                        const msg = res.data?.msg || "Erro ao criar fluxo!";
                        avisoToast(msg, "warning");
                        return;
                    }

                    const novoId =
                        res.data?.data ?? 
                        (() => { 
                            const loc = res.headers?.location;
                            const m = loc ? /\/(\d+)$/.exec(loc) : null;
                            return m ? Number(m[1]) : null;
                        })();

                    avisoToast("Fluxo criado com sucesso!", "success");

                    this.fecharModalInclusao();
                    this.getProcessosWorkflow();

                    if (novoId) {
                        this.$router.push({ name: "DetalhesWorkflow", params: { id: novoId } });
                    } else {
                        console.warn("ID do workflow não encontrado na resposta do POST.");
                    }
                } catch (err) {
                    console.error("Erro ao criar fluxo:", err);
                    const msg = err.response?.data?.msg || "Erro ao criar fluxo!";
                    avisoToast(msg, "warning");
                }
            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.getProcessosWorkflow();
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++;
                    this.getProcessosWorkflow();
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex;
                    this.getProcessosWorkflow();
                }
            },

            inativarProcessoWorkflow(idProcessoWorkflow) {
                Swal.fire({
                    title: 'Confirmar inativação do fluxo?',
                    html: `<p>Ao <strong>inativar</strong> este fluxo, os <strong>novos processos criados a partir deste momento</strong> não irão mais seguir este workflow.</p>
                          <p>Os processos que <strong>já estão em andamento</strong> e já utilizam este fluxo <strong>continuarão seguindo o mesmo padrão</strong> até serem finalizados.</p>
                          <p style="margin-top:.5rem;">Essa ação não pode ser revertida.</p>`,
                    showCancelButton: true,
                    confirmButtonText: 'Sim, excluir fluxo',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    focusCancel: true,
                    input: 'checkbox',
                    inputValue: 0,
                    inputPlaceholder: 'Entendo os impactos e desejo prosseguir com a inativação',
                    preConfirm: (ack) => {
                        if (!ack) {
                            Swal.showValidationMessage(
                                'Marque a confirmação para prosseguir com a inativação.'
                            );
                        }
                        return true;
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/ProcessoWorkflow/DeleteWorkflow`, { idProcessoWorkflow })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast('Fluxo excluído com sucesso!', 'success');
                                    this.getProcessosWorkflow();
                                } else {
                                    const erroMsg = res.data.msg || 'Erro ao excluir fluxo!';
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, 'warning');
                                }
                            })
                            .catch(err => {
                                console.error('Erro ao excluir fluxo:', err);
                                if (err.response && err.response.data) {
                                    avisoErro(err.response.data);
                                    avisoToast('Erro ao excluir fluxo!', 'warning');
                                } else {
                                    avisoErro(err.message || 'Erro desconhecido');
                                }
                            });
                    }
                });
            },

            abrirDetalhes(idProcessoWorkflow) {
                this.$router.push({ name: 'DetalhesWorkflow', params: { id: idProcessoWorkflow } });
            },

            formatarData(dataISO) {
                if (!dataISO) return '';
                const data = new Date(dataISO);
                return data.toLocaleDateString('pt-BR');
            },

            hashCode(str) {
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            },

            fecharModalInclusao() {
                const el = document.getElementById('ModalWorkflowInclusao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;

                if (bs && bs.Modal) {
                    const modalInstance = bs.Modal.getInstance(el);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            }

        },

        mounted: function () {
            this.load();
        },

        computed: {
            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize);
            },
            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages;
            },
            pagesToShow() {
                const maxPages = 5;
                const pages = [];

                let start = Math.max(this.currentPage - 2, 0);
                let end = Math.min(start + maxPages, this.totalPages);

                if (end - start < maxPages) {
                    start = Math.max(end - maxPages, 0);
                }

                for (let i = start; i < end; i++) {
                    pages.push(i);
                }

                return pages;
            },
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato === 'Sim';
            },
             legislacaoById() {
                const map = Object.create(null)
                for (const l of this.legislacoes) map[l.idLegislacao] = l.dsNome
                return map
            },
            tipoProcessoById() {
                const map = Object.create(null)
                for (const t of this.tiposProcessos) map[t.idTipoProcesso] = t.nmTipoProcesso
                return map
            },
            canAccess() {
                const u = this.user?.usuario
                return this.isAdmContrato || u?.idContrato === 0 || u?.dsLogin === 'aline.oliveira@negociospublicos.com.br' || this.user?.usuarioApi?.flAdministrador
            },
        }

    };
</script>
<style lang="css" scoped>
    .status-badge {
        display: inline-flex;
        align-items: center;
        padding: .25rem .6rem;
        border-radius: 999px;
        font-weight: 600;
        font-size: .75rem;
        line-height: 1;
        border: 1px solid transparent;
    }

    .status-badge--ativo {
        background: rgba(16, 185, 129, .12);
        color: #059669;
        border-color: rgba(16, 185, 129, .25);
    }

    .status-badge--inativo {
        background: rgba(239, 68, 68, .12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, .25);
    }

    .action-btn:disabled {
        opacity: .45;
        cursor: not-allowed;
        pointer-events: none;
        filter: grayscale(1);
    }

    .actions-disabled .action-btn {
        opacity: .45;
        cursor: not-allowed;
        pointer-events: none;
        filter: grayscale(1);
    }


    .btn-outline-primary {
        min-height: 40px;
    }
    .btn-md{
        z-index: 1001;
    }

    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }

    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section {
        flex: 1;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 24px 0;
        }

        .header-content {
            flex-direction: column;
            text-align: center;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }
    }

    /* Botões Modernos */
    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
        position: relative;
        overflow: hidden;
    }

    .modern-btn::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .modern-btn:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .modern-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
    }

    .modern-btn:active {
        transform: translateY(0);
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    }

    /* Search Box Moderna */
    .search-box {
        position: relative;
        flex: 1;
        max-width: 400px;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .modern-search-input:focus {
        background: #111827;
        border-color: #3b82f6;
    }

    /* Botões de Ação na Tabela */
    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

    .action-btn::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .action-btn:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

    .action-btn-view:hover {
        background: linear-gradient(135deg, #059669 0%, #047857 100%);
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
    }

    .action-btn-delete {
        background: transparent;
        color: #ef4444;
        border-color: #ef4444;
    }

    .action-btn-delete::before {
        background: rgba(239, 68, 68, 0.1);
    }

    .action-btn-delete:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
        border-color: #ef4444;
    }

    .action-btn:active {
        transform: translateY(0);
    }

    @media (max-width: 768px) {
        .action-text {
            display: none;
        }

        .action-btn {
            padding: 12px 16px;
            min-width: 48px;
            min-height: 48px;
            flex: 1;
            justify-content: center;
            font-size: 14px;
        }

        .action-buttons {
            gap: 10px;
            flex-wrap: nowrap;
            justify-content: stretch;
            width: 100%;
        }
    }

    .th-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        min-height: 20px;
    }

    .th-title {
        text-align: center;
        font-weight: 700;
        letter-spacing: 0.3px;
    }

    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 22px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px
    }

    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
        border-collapse: collapse;
        background: white;
    }

        .custom-table th,
        .custom-table td {
            padding: 16px 20px;
            text-align: left;
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s ease;
        }

        .custom-table td {
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 15px;
            color: #374151;
        }

        .custom-table th {
            font-weight: 700;
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

    [data-bs-theme="dark"] .custom-table {
        background: #1f2937;
    }

    [data-bs-theme="dark"] .custom-table td {
        color: #e5e7eb;
    }

    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        font-family: 'Segoe UI';
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    .pagination-controls {
        display: flex;
        gap: 6px;
    }

    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        line-height: 1;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        background: white;
    }

        .page-box:hover {
            background-color: #f3f4f6;
            border-color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
        }

        .page-box.disabled {
            opacity: 0.4;
            pointer-events: none;
            cursor: default;
        }

        .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
            border-color: #2563eb;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    [data-bs-theme="dark"] .page-box {
        background-color: #1e293b;
        border: 2px solid #334155;
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .page-box:hover {
            background-color: #334155;
            border-color: #3b82f6;
        }

        [data-bs-theme="dark"] .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid #3b82f6;
        }

    .navigation-symbol {
        display: inline-block;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        animation: fadeIn 0.2s ease-out;
        padding: 20px;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .modal-content-custom {
        background: white;
        padding: 32px;
        border-radius: 16px;
        width: 100%;
        max-width: 700px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
        animation: slideUp 0.3s ease-out;
        max-height: 90vh;
        overflow-y: auto;
        position: relative;
    }

    [data-bs-theme="dark"] .modal-content-custom {
        background: #1f2937;
    }

    .btn-close-custom {
        position: absolute;
        top: -12px;
        right: -12px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #ffffff;
        border: 2px solid #e9ecef;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10;
    }

    .btn-close-custom:hover {
        transform: scale(1.1);
        background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
        border-color: #dc3545;
        box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
    }

    .btn-close-custom:hover svg {
        color: #ffffff;
    }

    .btn-close-custom svg {
        color: #6c757d;
        transition: all 0.3s ease;
    }

    .btn-close-custom:active {
        transform: scale(0.95);
    }

    .custom-table tbody tr {
        transition: all 0.2s ease;
    }

    .custom-table tbody tr:hover {
        background-color: #f9fafb;
        transform: scale(1.002);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: #374151;
        color: white;
    }

    .separador {
        height: 2px;
        background: linear-gradient(to right, transparent, #e5e7eb 20%, #e5e7eb 80%, transparent);
        margin-top: 12px;
        margin-bottom: 20px;
    }

    /* Estado Vazio */
    .empty-state {
        padding: 80px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    [data-bs-theme="dark"] .empty-icon {
        color: #475569;
    }

    .empty-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

        .custom-table thead {
            display: none;
        }

        .custom-table tr {
            margin-bottom: 16px;
            border-radius: 8px;
            box-shadow: 0 1px 3px rgba(89, 89, 89, 0.5);
            overflow: hidden;
        }

        .custom-table td {
            text-align: left !important;
            padding: 12px 16px;
            position: relative;
            border: none;
            border-bottom: 1px solid #eee;
            display: flex;
            flex-direction: column;
        }

        .custom-table td::before {
            content: attr(data-label);
            font-weight: 600;
            display: block;
            margin-bottom: 8px;
            color: #6b7280;
            font-size: 13px;
        }

        .custom-table td:last-child {
            border-bottom: none;
        }

        .action-cell {
            white-space: normal !important;
            width: 100% !important;
            padding: 16px !important;
        }

        .action-cell::before {
            margin-bottom: 12px;
        }

        .action-cell .action-buttons {
            margin-top: 0;
            width: 100%;
        }
    }

    /* Modal moderno */
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 22px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modal-modern-header .header-icon {
        width: 60px;
        height: 60px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.16) 0%, rgba(16, 185, 129, 0.16) 100%);
        color: #2563eb;
        flex-shrink: 0;
    }

    .modal-modern-header .header-text {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .modal-modern-header .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-modern-header .header-text p {
        margin: 0;
        font-size: 14px;
        color: #475569;
        max-width: 420px;
        line-height: 1.45;
    }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .intro-text {
        font-size: 14px;
        color: #475569;
        line-height: 1.5;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
    }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background-color: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .modern-modal .form-control:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        background-color: #ffffff;
    }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .info-chip {
        display: inline-flex;
        align-items: flex-start;
        gap: 10px;
        padding: 14px 16px;
        border-radius: 12px;
        background: rgba(37, 99, 235, 0.08);
        color: #1e3a8a;
        font-size: 13px;
        line-height: 1.45;
    }

    .info-chip svg {
        flex-shrink: 0;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }
    }

    @media (max-width: 576px) {
        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }

        .modal-modern-body {
            padding: 22px 18px;
        }

        .modal-modern-footer {
            padding: 0 18px 22px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111827 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modal-modern-footer {
        background: transparent;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.24) 0%, rgba(16, 185, 129, 0.24) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p,
    [data-bs-theme="dark"] .intro-text {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background-color: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control:focus {
        background-color: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .modern-modal select.form-control,
    [data-bs-theme="dark"] .modern-modal select.form-control:focus {
        background-color: rgba(15, 23, 42, 0.85);
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
    }

        [data-bs-theme="dark"] .modern-modal select.form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control option {
        background: #1f2937;
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }

    [data-bs-theme="dark"] .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .info-chip {
        background: rgba(37, 99, 235, 0.18);
        color: #bfdbfe;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

</style>

